<script>
    import Column from "./Column.svelte";
    import Grid from "./Grid.svelte";

    export let sectionData;
    // console.log('Section sectionData', sectionData);

</script>

<section class="section">
    {#if sectionData.title}
        <h3>{sectionData.title}</h3>
    {/if}
    <div class="columnContent">
        {#if Array.isArray(sectionData.columns)}
            {#each sectionData.columns as column}
                <Column
                    columnData = {column}
                />
            {/each}
        {/if}
        {#if Array.isArray(sectionData.grids)}
            {#each sectionData.grids as grid}
                <Grid
                    gridData = {grid}
                />
            {/each}
        {/if}
    </div>
</section>

<style>
    .section {
        display: flex;
        flex-direction: column;
    }
    .columnContent {
        display: grid;
        /* grid-template-columns: repeat(12, 1fr); */
        gap: 10px;
    }
</style>